import { PRIVATE_API_URL } from "../../dataProvider";
import { PUBLIC_API_URL } from "../../authProvider";
import { logout } from "./Logout";
import { toast } from "react-toastify";
import base64 from "base-64";

const POSTHeaders = async () => ({
  Authorization: `Bearer ${await localStorage.getItem("accessToken")}`,
  "Content-Type": "application/json; charset=utf-8"
});

const GETHeaders = async () => ({
  Authorization: `Bearer ${await localStorage.getItem("accessToken")}`
});

//==================Homework Scraping API========================

const Scrape = async (endPoint) => {
  let response = await fetch(`${PRIVATE_API_URL}/scraper/${endPoint}`, {
    method: "GET",
    headers: await GETHeaders(),
  });

  let jsonResponse = await response.json();
  if (response.status === 400) showErrorToast(jsonResponse.msg);
  else if (jsonResponse.msg === 'Done') showSuccessToast(jsonResponse.msg);
};

const GetProgress = async () => {
  let response = await fetch(`${PRIVATE_API_URL}/progress`, {
    method: "GET",
    headers: await GETHeaders(),
  });

  let jsonResponse = await response.json();
  return jsonResponse.data
};

const UpdateProgress = async (data) => {
  let response = await fetch(`${PRIVATE_API_URL}/progress`, {
    method: "PUT",
    headers: await POSTHeaders(),
    body: JSON.stringify(data)
  });

  return response.status
};










const applyChangedProxy = async () => {
  let response = await fetch(`${PRIVATE_API_URL}/tradeRev-auto-proxys/ApplyChangedProxy`, {
    method: "POST",
    headers: await POSTHeaders(),
  });

  let jsonResponse = await response.json();
  if (response.status === 500) showErrorToast(jsonResponse.msg);
  else showSuccessToast(jsonResponse.msg);
};

const boxesBidApi = async () => {
  let response = await fetch(`${PRIVATE_API_URL}/tradeRev-auto-proxys/SingleBid`, {
    method: "POST",
    headers: await POSTHeaders(),
  });
  console.log(response.status)
  if (response.status !== 200){
    console.log(await response.text());
    showErrorToast("something went wrong");
  }else{
    let jsonResponse = await response.json();
    showSuccessToast(`Successfully Bid $100 on ${jsonResponse.count} units`, false);
  }
}





const keepAccessTokenUpdated = async (showToast = true) => {
  try {
    let accessToken = await localStorage.getItem("accessToken");
    let encodedPayload = accessToken.split(".")[1];
    let decodedPayload = JSON.parse(base64.decode(encodedPayload));
    if (decodedPayload && decodedPayload.exp) {
      let expireTime = decodedPayload.exp;
      if (Date.now() + 10000 >= expireTime * 1000) {
        //accessToken is expiring in 10 seconds
        await getNewAccessToken(showToast);
      }
    } else logout(showToast);
  } catch (error) {
    logout(showToast);
  }
};

const getNewAccessToken = async (showToast = true) => {
  let response = await fetch(`${PUBLIC_API_URL}/GetNewAccessToken`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${await localStorage.getItem("refreshToken")}`,
      "Content-Type": "application/json"
    }
  });

  let jsonResponse = await response.json();
  if (response.status === 401) logout(showToast);
  else await localStorage.setItem("accessToken", jsonResponse.accessToken);
};

const getExchangeRate_USDBase = async () => {
  const url = 'https://adsynth-ofx-quotewidget-prod.herokuapp.com/api/1'
  const bodyData = { "method": "spotRateHistory", "data": { "base": "USD", "term": "CAD", "period": "week" } }

  try {
    let res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Accept: "application/json, text/javascript, */*; q=0.01",
        Origin: "https://widget-yahoo.ofx.com",
        Referer: "https://widget-yahoo.ofx.com/?locale=Canada&base=USD&term=CAD"
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      body: JSON.stringify(bodyData), // body data type must match "Content-Type" header
    })

    if (res.status !== 200) {
      showErrorToast("⚠️Could Not Get Exchange Rate...");
      console.log('res-------', res);

    } else {
      res = await res.json();
      return res.data.CurrentInterbankRate;
    }
  } catch (error) {
    showErrorToast("⚠️Could Not Get Exchange Rate...");
  }

};

//==================Toast Alerts========================

const showSuccessToast = (text = "🎉Success!", uptime=5000) => {
  toast.success(text, {
    position: "bottom-center",
    autoClose: uptime,
    hideProgressBar: true,
    pauseOnHover: true,
    draggable: false
  });
};

const showErrorToast = (text = "⚠️Something Bad Happened...") => {
  toast.error(text, {
    position: "bottom-center",
    autoClose: 5000,
    hideProgressBar: true,
    pauseOnHover: true,
    draggable: false
  });
};

//==================Password========================

const resetPassword = async (username, email) => {
  let data = { username, email };
  let response = await fetch(`${PUBLIC_API_URL}/user/reset_password`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  });

  let jsonResponse = await response.json();
  return jsonResponse.msg;
};

const updatePassword = async (userID, oldPassword, newPassword) => {
  let data = { userID, oldPassword, newPassword };
  let response = await fetch(`${PRIVATE_API_URL}/user/update_password`, {
    method: "PUT",
    headers: await POSTHeaders(),
    body: JSON.stringify(data)
  });

  let jsonResponse = await response.json();
  return jsonResponse.msg;
};

export {

  applyChangedProxy,
  boxesBidApi,
  resetPassword,
  keepAccessTokenUpdated,
  getExchangeRate_USDBase,
  updatePassword,
  Scrape,
  GetProgress,
  UpdateProgress
};
